import {useEffect, useRef} from 'react';
import DomUtils from '../../../v2/utils/DomUtils';
import Track from '../../../v2/utils/tracking';

export function ShoeSizeMe(props) {
  const loadedShoeSizeScript = useRef(false);
  
  useEffect(() => {
    window.ShoeSizeShoppingCartConfirmation = {
      shopID: props.shoeSizeId,
      orderID: props.orderNumber,
    };
    
    if (!loadedShoeSizeScript.current) {
      const timeDate = Math.round(new Date().getTime() / 1000);
      
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json',
      };
      
      fetch('https://shoesize.me/api/config/integrity', {
        method: 'GET',
        mode: 'cors',
        headers,
      }).then((response) => {
        response.json()
          .then((integrity) => {
            const confirmIntegrity = integrity?.confirm_integrity;
            DomUtils.addScript(`${'https://shoesize.me/plugin/confirm.js?'
                + 'shopid='}${encodeURIComponent(window.ShoeSizeShoppingCartConfirmation.shopID)
            }&sid=${timeDate}`, true, confirmIntegrity)
              .then(() => {
                loadedShoeSizeScript.current = true;
              })
              .catch(() => Track.error('Error loading shoesize.me script'));
          })
          .catch(() => Track.error('Error parsing integrity response'));
      })
        .catch(() => Track.error('Error loading integrity script'));
    }
  }, [props.orderNumber, props.shoeSizeId]);
  
  return null;
}

export default ShoeSizeMe;
